import { Location } from "react-router-dom"
import { getScreenModeFromScreen, ScreenModes } from "./UI"

export enum Screen {
  home = "home",
  avatars = "avatars",
  myAgents = "myAgents",
  knowledgeBase = "knowledgeBase",
  conversations = "conversations",
  analytics = "analytics",
  videos = "videos",
  settings = "settings",
  apiKeys = "apiKeys",
  auth = "auth",
  enterPassword = "enterPassword",
}

export enum AuthScreen {
  manageAccount = "manageAccount",
  resetPassword = "resetPassword",
  newPassword = "newPassword",
  verifyEmail = "verifyEmail",
}

export enum SettingsScreen {
  subscription = "subscription",
}

export enum AvatarScreen {
  selectAvatar = "selectAvatar",
  prepare = "createAvatar/prepare",
  checkInputs = "createAvatar/checkInputs",
  uploadVideo = "createAvatar/uploadVideo",
  recordVideo = "createAvatar/recordVideo",
  finalResult = "createAvatar/finalResult",
}

export enum VideoScreen {
  selectVideoAvatar = "selectVideoAvatar",
  createVideoMessage = "createVideoMessage",
  finalResult = "finalResult",
  generateVideos = "generateVideos",
  videoList = "videoList",
}

export enum AgentScreen {
  selectAvatar = "selectAvatar",
  agentsInfo = "agentsInfo",
  trainAgent = "trainAgent",
  finalResult = "finalResult",
  agentDetails = "agentDetails",
  conversationDetails = "conversationDetails",
}

export enum PageMode {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
}

export enum ConversationScreen {
  conversationDetails = "conversationDetails",
}

export const getStepNumberFromScreen = (screen: AvatarScreen | VideoScreen) => {
  switch (screen) {
    case VideoScreen.selectVideoAvatar:
      return 1
    case VideoScreen.createVideoMessage:
      return 2
    case VideoScreen.generateVideos:
      return 3
    case VideoScreen.videoList:
      return 3
  }
}

export const getBoldTextFromScreen = (screen: AvatarScreen | VideoScreen) => {
  switch (screen) {
    case AvatarScreen.selectAvatar:
    case VideoScreen.selectVideoAvatar:
      return "Select avatar"
    case VideoScreen.generateVideos:
      return "Final result"
    case VideoScreen.createVideoMessage:
      return "Define message"
  }
}

export const getNrOfStepsFromScreenMode = (screenMode: ScreenModes): number => {
  switch (screenMode) {
    case ScreenModes.avatar:
      return 2
    case ScreenModes.video:
      return 3
  }
}

export const getFirstTextFromScreenMode = (
  screen: AvatarScreen | VideoScreen,
): string => {
  switch (getScreenModeFromScreen(screen)) {
    case ScreenModes.avatar:
      return "Create Avatar"
    case ScreenModes.video:
      return "New Video"
  }
}

export const getDescriptionTextFromScreen = (
  screen: AvatarScreen | VideoScreen,
) => {
  switch (screen) {
    case AvatarScreen.selectAvatar:
    case VideoScreen.selectVideoAvatar:
      return "Please select from the available avatars or create your own"
    case VideoScreen.createVideoMessage:
      return "Please define your message."
    case VideoScreen.generateVideos:
      return "Please proceed to the payment to see & download the rest of the videos"
    case VideoScreen.videoList:
      return "Video generation is in progress. Estimated processing time: 2h."
  }
}

export const getScreenFromLocation = (
  location: Location,
): AvatarScreen | VideoScreen => {
  const splitLocation = location.pathname.split("/")
  return splitLocation[splitLocation.length - 1] as AvatarScreen | VideoScreen
}
